'use strict';
// $(window).on('beforeunload', function(e) {
// if(window.location.pathname==='/'||window.location.pathname==='/uk'||window.location.pathname==='/uk/')
// {
//     $(window).scrollTop(0);
// }
//
// });
(function (w, d) {
    var b = d.getElementsByTagName('body')[0];
    var s = d.createElement("script");
    var v = !("IntersectionObserver" in w) ? "8.17.0" : "10.20.0";
    s.async = true; // This includes the script as async. See the "recipes" section for more information about async loading of LazyLoad.
    s.src = "https://cdn.jsdelivr.net/npm/vanilla-lazyload@" + v + "/dist/lazyload.min.js";
    w.lazyLoadOptions = {elements_selector: ".lazy"};
    b.appendChild(s);
}(window, document));
(function ($) {
    if(typeof toastr !== "undefined") {
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": "toast-top-center",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "15000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
    }
    // Configure
    code2magic.settings({
        showMessage: {
            providers: {
                modal: function (message_data) {
                    $.fancybox.open(message_data, {});
                },
                toastr: function (message_data) {
                    if (message_data.success === true) {
                        toastr.success(message_data.message);
                    } else {
                        toastr.error(message_data.message);
                    }
                }
            },
            providerDefault: 'toastr'
        },
        timeout: {
            handlerDefault: 500
        }
    });
    $.ajaxPrefilter(function (options, originalOptions, xhr) {
        let csrf = $('meta[name=csrf-token]').attr('content');
        if (!options.crossDomain && csrf) {
            xhr.setRequestHeader('X-CSRF-Token', csrf);
        }
    });
    $(document).ajaxComplete(function (event, xhr) {
        var url = xhr && xhr.getResponseHeader('X-Redirect');
        if (url) {
            window.location.assign(url);
        }
    });
    // $(document).on('ajaxComplete ready', function (event) {
    //     $('.lazy').lazy();
    // });
    /**
     * .add-wishlist
     * init config on doc ready
     */
    $(document).ready(function () {
        if (typeof js_vars === 'undefined') {
            return;
        }
        $.config = js_vars;
        $('#middle_cart_counter').html(middle_cart.quantity);
        $(document).trigger('js_ready', $.config);
        var toaster_html = $('#toastr');
        if (toaster_html.html().trim().length > 0) {
            toastr.success(toaster_html.html());
        }
    });
    /**
     * process config ready event
     */
    $(document).on('js_ready', function (event, config) {
        /**
         * init cart module
         */
        $.Cart.init($.config.cart_settings);
        /**
         * add cart operations request handlers
         */
        $(document).on('click', $.Cart.settings.add, function (event) {
            event.preventDefault();
            clearTimeout($.Cart.timeout.add);
            const data = {
                id: this.getAttribute($.Cart.settings.addattr),
                combination: this.getAttribute('data-com'),
            };
            $.Cart.timeout.add = setTimeout(function () {
                $.Cart.add(data);
            }, 100);
        });
        $(document).on('click', $.Cart.settings.del, function (e) {
            e.preventDefault();
            $.Cart.del({id: this.getAttribute($.Cart.settings.delattr) + '-' + this.getAttribute('data-com')});
        });
        /**
         * add cart operations response event handlers
         */
        $(document).on('updTpl.cart', function (event, data) {
            if(typeof window.cart_set === 'function'){
                window.cart_set(data.cart.models);
            }
            var cart_header = $('.cart_header_wrap'),
                cart_order = $('#cart_order_wrap'),
                cart_popup = $('.cart_popup');
            $('.header-wishlist__counter').html(data.cart.quantity);
            if (cart_header.length > 0) {
                var tmpl_cart = code2magic.render('tmpl-cart-header', data);
                cart_header.each(function (i, el) {
                    $(el).html(tmpl_cart);
                });
            }
            if (cart_order.length > 0) {
                cart_order.html(code2magic.render('tmpl-cart-full', $.extend({is_order_page: true}, data)));
            }
            if (cart_popup.length > 0) {
                cart_popup.html(code2magic.render('tmpl-cart-popup', $.extend({is_order_page: false}, data)));
            }
            $(document).trigger('tmpl_rendered');
        });
        $(document).on('get.cart', function (event, data) {
            var header = $('.header-sign-in');
            if (header.length > 0) {
                header.html($.render('tmpl-profile-buttons', data.profile));
            }
        });
        $(document).on('add.cart', function (event, data) {


        });
        $(document).on('count.cart', function (event, data) {
            $.Cart.showMessage(data.popup);
        });
        $(document).on('del.cart', function (event, data) {
            $.Cart.showMessage(data.popup);
        });
        /**
         * make ajax not war
         */
        $.Cart.get();
    });
    /**
     * submit form
     */
    $(document).on('click', '[data-submit]', function (event) {
        event.preventDefault();
        $('#' + $(this).attr('data-submit')).submit();
    });
    /**
     * send form over ajax and render html response in form parent element
     */
    var submit_timeout = void 0;
    $(document).on('submit', '[data-ajax=1]', function (event) {
        event.preventDefault();
        var form = $(this);
        var content = form.parent();
        var content_wrap = form.closest('.fancybox-slide');
        form.find('[type=submit]').each(function () {
            $(this).prop('disabled', true);
        });
        form.find('[type=submit]').each(function () {
            $(this).prop('disabled', true);
        });
        const closure = function () {
            $.ajax({
                url: form.attr('action'),
                type: form.attr('method'),
                data: form.serialize(),
                // dataType: 'html',
                // contentType:false,
                // processData:false,
                success: function (data) {
                    content.html(data);
                    $(content_wrap.length ? content_wrap : 'html, body').animate({
                        scrollTop: form.offset().top - 100
                    }, 100);
                }
            }).always(function () {
                form.find('[type=submit]').each(function () {
                    $(this).prop('disabled', false);
                });
            });
        };
        clearTimeout(submit_timeout);
        submit_timeout = setTimeout(closure, 500);
        return false;
    });
})($);
